export class LayoutProposta {

  public PessoaFisica = 1;
  public PessoaJuridicaAgropecuaria = 2;
  public PessoaJuridicaRevenda = 3;
  public PessoaJuridicaUsina = 4;
  public PessoaJuridica = 5;
  public PfComCnpj = 6;
  public PfParceriaAgricola = 7;

  getArray() {
    return [
      this.PessoaFisica,
      this.PessoaJuridicaAgropecuaria,
      this.PessoaJuridicaRevenda,
      this.PessoaJuridicaUsina,
      this.PessoaJuridica,
      this.PfComCnpj,
      this.PfParceriaAgricola
    ];
  }

  getDescricao(layout: number) {
    switch(layout) {
      case 1: return "Pessoa Física";
      case 2: return "Pessoa Jurídica - Agropecuária";
      case 3: return "Pessoa Jurídica - Revenda";
      case 4: return "Pessoa Jurídica - Usina";
      case 5: return "Pessoa Jurídica";
      case 6: return "Pessoa Física com CNPJ";
      case 7: return "Pessoa Física - Parceria Agrícola";
      default: return "N/D";
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/models/layout-proposta.ts